import { useRef, useEffect, useState } from 'react';
import style from './Sec02.module.css';
import secImg01 from '../images/sec02_img01.png';
import secImg02 from '../images/sec02_img02.png';

function Sec02( {sec02Ref} ) {

    
    return (
        <div className={style.wrap} ref={sec02Ref}>
            <div className={style.content_box}>
                <div className={style.img_box}>
                    <img src={secImg01} alt='합성 S니코틴 제조 생산'/>
                </div>
                <div className={style.txt_box}>
                    <h5>국내 유일무이한 합성 S니코틴 제조 생산</h5>
                    <h4>
                        믿고 사용할 수 있는 기술력
                    </h4>
                    <p>
                        직접 제조, 생산한 니코틴만을 사용하며<br />
                        담배특이니트로사민 4종 불검출.
                    </p>
                </div>
            </div>
            <div className={`${style.content_box} ${style.content_box02}`}>
                <div className={style.img_box}>
                    <img src={secImg02} alt='철저한 공정 확실한 품질' />
                </div>
                <div className={style.txt_box}>
                    <h5>철저한 공정 확실한 품질</h5>
                    <h4>신뢰할 수 있는 기업</h4>
                    <p>
                        푸푸케미칼은 철저한 공정과 <br />
                        확실한 품질로 신뢰를 증명합니다.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Sec02;